/* ===========================================================================
   ROUTINES YOU'LL LOVE
   The rail is a native scroll container, so swipe already works everywhere
   without any of this. All this does is drive the same scroll from the arrow
   buttons and grey them out at the ends.
   =========================================================================== */
(function () {
  function init(root) {
    if (!root || root.dataset.fcrInit === '1') return;
    root.dataset.fcrInit = '1';

    var track = root.querySelector('[data-fc-track]');
    var prev = root.querySelector('[data-fc-prev]');
    var next = root.querySelector('[data-fc-next]');
    if (!track) return;

    function step() {
      var card = track.querySelector('.fc-routines__card');
      if (!card) return track.clientWidth;
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth;
      // a couple of pixels of tolerance, browsers round sub-pixel scroll
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });

    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    /* ---- the progress line ----------------------------------------------
       Modelled on a scrollbar rather than a percentage fill: the thumb is as
       wide as the portion of the rail you can currently see, and it slides.
       That reads as "there is more over there" in a way a growing bar does
       not. It can also be clicked or dragged to move.
       -------------------------------------------------------------------- */
    var progress = root.querySelector('[data-fc-progress]');
    var bar = root.querySelector('[data-fc-progress-bar]');
    var dragging = false;

    function updateProgress() {
      if (!progress || !bar) return;
      var sw = track.scrollWidth;
      var cw = track.clientWidth;
      if (sw <= cw + 2) { progress.hidden = true; return; }
      progress.hidden = false;
      var thumb = cw / sw;
      bar.style.width = (thumb * 100) + '%';
      bar.style.left = ((track.scrollLeft / sw) * 100) + '%';
    }

    function seek(clientX, smooth) {
      var box = progress.getBoundingClientRect();
      var pct = (clientX - box.left) / box.width;
      pct = Math.max(0, Math.min(1, pct));
      var max = track.scrollWidth - track.clientWidth;
      track.scrollTo({ left: pct * max, behavior: smooth ? 'smooth' : 'auto' });
    }

    if (progress) {
      progress.addEventListener('pointerdown', function (e) {
        dragging = true;
        if (progress.setPointerCapture) progress.setPointerCapture(e.pointerId);
        seek(e.clientX, true);
        e.preventDefault();
      });
      progress.addEventListener('pointermove', function (e) {
        if (dragging) seek(e.clientX, false);
      });
      ['pointerup', 'pointercancel'].forEach(function (evt) {
        progress.addEventListener(evt, function () { dragging = false; });
      });
    }

    function update() { updateArrows(); updateProgress(); }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }, { passive: true });

    window.addEventListener('resize', update);

    // videos are muted and autoplaying, so pause the ones nobody is looking at
    var videos = track.querySelectorAll('video');
    if (videos.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            var playing = v.play();
            if (playing && playing.catch) playing.catch(function () {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: 0.35 });
      videos.forEach(function (v) { io.observe(v); });
    }

    update();
  }

  function boot() {
    document.querySelectorAll('.fc-routines').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
